import AccountSettingsModule from '@/modules/account-settings/AccountSettingsModule';

export default AccountSettingsModule;
